import ephemeride, { en as ephemerideEN, ca as ephemerideCA } from './ephemeride'
import feedInitial, { en as feedInitialEN, ca as feedInitialCA } from './feedInitial'
import searchResults, { en as searchResultsEN, ca as searchResultsCA } from './searchResults'
import searchbar, { en as searchbarEN, ca as searchbarCA } from './searchbar'
import seeMore, { en as seeMoreEN, ca as seeMoreCA } from './seeMore'

export default {
  searchbar,
  feedInitial,
  searchResults,
  seeMore,
  ephemeride
}

export const en = {
  searchbar: searchbarEN,
  feedInitial: feedInitialEN,
  searchResults: searchResultsEN,
  seeMore: seeMoreEN,
  ephemeride: ephemerideEN
}

export const ca = {
  searchbar: searchbarCA,
  feedInitial: feedInitialCA,
  searchResults: searchResultsCA,
  seeMore: seeMoreCA,
  ephemeride: ephemerideCA
}
